import React from 'react';

import { Link } from 'react-router-dom';

//// import './style.css'

import PostShop from '../../../../components/postShop';
import { getUrlImage } from '../../../../constants/config';

import { useSelector, useDispatch } from 'react-redux';

const Results = (props) => {
    const { shops, handleSetSearchValue } = props;

    const status = useSelector((state) => state.search.status);
    const message = useSelector((state) => state.search.message);
    const categoriesById = useSelector(
        (state) => state.initData.categoriesById
    );

    return (
        <div className="results _search">
            {(shops &&
                shops.length > 0 &&
                shops.map((item, index) => {
                    const {
                        id,
                        title,
                        previewUrl,
                        logoUrl,
                        categoryTitle,
                        subTitle,
                        sale,
                        attributes,
                    } = item;

                    return (
                        <div className="results__item" key={id}>
                            <Link
                                className="results__item-link"
                                to={`/shop/${id}`}
                            >
                                {title}
                            </Link>
                        </div>
                    );
                })) ||
                (message && <div className="results__item">{message}</div>)}
            {message == '' && shops && !shops.length && (
                <div className="results__often">
                    <div className="often__title">Часто ищут</div>
                    <div className="often__list">
                        <div className="results__item">
                            <a
                                onClick={e =>
                                    handleSetSearchValue(e, 'Летуаль')
                                }
                                href="#"
                                className="results__item-link"
                            >
                                Летуаль
                            </a>
                        </div>
                        <div className="results__item">
                            <a
                                onClick={e =>
                                    handleSetSearchValue(e, 'Рив Гош')
                                }
                                href="#"
                                className="results__item-link"
                            >
                                Рив Гош
                            </a>
                        </div>
                        <div className="results__item">
                            <a
                                onClick={e => handleSetSearchValue(e, 'Обувь')}
                                href="#"
                                className="results__item-link"
                            >
                                Обувь
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Results;
